import { styled } from '@mui/system';
import { StepIconProps } from '@mui/material';
import Check from '@mui/icons-material/Check';

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(
  ({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
      color: theme.palette.primary.main,
    }),
    '& .QontoStepIcon-completedIcon': {
      color: theme.palette.primary.main,
      zIndex: 1,
      fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: 'currentColor',
    },
  }),
);
const StepIcon = ({ active, className, completed }: StepIconProps) => (
  <QontoStepIconRoot ownerState={{ active }} className={className}>
    {completed ? (
      <Check className="QontoStepIcon-completedIcon" />
    ) : (
      <div className="QontoStepIcon-circle" />
    )}
  </QontoStepIconRoot>
);

export {
  StepIcon,
};
